import React from 'react';

import map_placeholder from "../../assets/img/map-placeholder.jpg";


import fb from "../../assets/img/social/fb.jpg";
import insta from "../../assets/img/social/insta.jpg";
import yt from "../../assets/img/social/yt.jpg";

import mail from "../../assets/img/social/mail.jpg";
import phone from "../../assets/img/social/phone.jpg";
import location from "../../assets/img/social/location.jpg";
import {FormattedMessage} from "react-intl";

var mapboxgl = require('mapbox-gl');
var MapboxLanguage = require('@mapbox/mapbox-gl-language');

const links = require("../../translations/links.json");

export default class Map extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mapLoaded: false
        };
        this.initMap = this._initMap.bind(this)
    }

    componentDidMount() {
        this.initMap()
        //window.mapboxgl.setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.1.0/mapbox-gl-rtl-text.js');

    }

    _initMap() {
        // fixme: remove this when building to production
        //return;

        mapboxgl.accessToken = links.mapToken;

        const map = new mapboxgl.Map({
            container: 'mapbox-map',
            style: 'mapbox://styles/mapbox/bright-v9',
            center: links.coord,
            zoom: 14
        });
        map.once('style.load', (ev) => {
            if (!this.state.mapLoaded) {
                this.setState({
                    mapLoaded: true
                })
            }
        });


        const marker = new mapboxgl.Marker();

        marker.setLngLat(links.coord);

        // Ensure it's added to the map. This is safe to call if it's already added.
        marker.addTo(map);

        const language = new MapboxLanguage({
            defaultLanguage: 'en'
        });
        map.addControl(language);
        map.addControl(new mapboxgl.NavigationControl());

    }

    render() {

        return <div className={"map r"}>
            <div className={"contact-info c-1-3"}>
                <div className={"location-title black"}>
                    <h2><FormattedMessage id={"map.title"}/></h2>
                </div>
                <div className={"location-info"}>
                    <div className={"social-acounts"}>
                        <a href={links.fb} target="_blank" rel="noopener noreferrer">
                            <img src={fb} alt={"facebook"}/></a>
                        <a href={links.insta} target="_blank" rel="noopener noreferrer">
                            <img src={insta} alt={"instagram"}/></a>
                        <a href={links.yt} target="_blank" rel="noopener noreferrer">
                            <img src={yt} alt={"youtube"}/></a>
                    </div>
                    <div className={"phone-mail-address"}>
                        <div>
                            <a href={"tel:" + links.phone}>
                                <img src={phone} alt={"phone"}/>{links.phone}
                            </a>
                        </div>
                        <div>
                            <a href={"mailto:" + links.mail}>
                                <img src={mail} alt={"mail"}/>{links.mail}
                            </a>
                        </div>
                        <div>
                            <img src={location} alt={"location"}/>
                            <span>{links.adresss[this.props.lang]} {" "}
                                {links.location[this.props.lang]}</span>

                        </div>

                    </div>

                </div>
            </div>
            <div className={"mapbox-map-container  c-2-3"}>
                <div id="mapbox-map"
                     className={this.state.mapLoaded ? "mapbox-map" : "mapbox-map hide_it"}/>

                <div
                    className={this.state.mapLoaded ? "mapbox-map-holder hide_it" : "mapbox-map-holder"}
                    style={{backgroundImage: "url(" + map_placeholder + ")"}}/>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/Map.js